import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Stack,
  Typography,
  CardHeader,
  CardContent,
  Card,
  Tooltip,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Icon,
  TableContainer,
  Button,
  Divider
} from 'investira.react.components';
import { dates, validators } from 'investira.sdk';
import { displays } from 'investira.react.lib';
import { PessoaImage } from '../../../components/molecules';
import services from '../../../services';
import utils from '../../../utils';

const ComparadorGestorAdm = memo(({ ativos = [] }) => {
  return (
    <Stack flexGrow={1}>
      <Card component="section">
        <CardHeader
          title={
            <Stack direction="row" gap={1} alignItems="center">
              <Typography
                variant="subtitle1"
                component="h2"
                color="textPrimary"
                sx={{ fontWeight: 600 }}
                noWrap>
                Gestores e Administradores
              </Typography>
            </Stack>
          }
        />
        <CardContent sx={{ pt: 0 }}>
          <Stack direction="row" gap={2}>
            {ativos.map((pAtivo, pIndex) => {
              const xGestor = pAtivo.gestorDetalhe;

              return (
                <React.Fragment key={pIndex}>
                  {pIndex > 0 ? (
                    <Divider
                      orientation="vertical"
                      flexItem
                      sx={{ borderColor: 'secondary.light' }}
                    />
                  ) : null}
                  <Stack flex={1} gap={2}>
                    <Stack gap={1} sx={{ minHeight: '80px' }}>
                      <Stack>
                        <PessoaImage
                          logoPessoaId={pAtivo.logo_pessoa_id}
                          alt={pAtivo.pessoa_fantasia}
                          hasLogo={pAtivo.logo_ok}
                          size={24}
                        />
                      </Stack>
                      <Typography variant="subtitle2" component="h3" sx={{ fontWeight: 600 }}>
                        {utils.helpers.getAtivoDescricao(pAtivo)}
                      </Typography>
                    </Stack>
                    <Divider />
                    {/* Gestor */}
                    <Stack gap={1} sx={{ minHeight: '100px' }}>
                      <Stack direction="row" alignItems="center" justifyContent="space-between">
                        <Stack>
                          <Typography variant="caption" color="textPrimary">
                            <b>Gestor</b>
                          </Typography>
                        </Stack>

                        {pAtivo.gestor_pessoa_id && (
                          <Stack>
                            <Button
                              component={Link}
                              title={xGestor?.pessoa_fantasia}
                              endIcon={<Icon iconName="arrow-next" size={12} />}
                              size="small"
                              to={`/empresas/${pAtivo.gestor_pessoa_id}`}
                              sx={{
                                px: 2,
                                textTransform: 'capitalize'
                              }}>
                              {`${utils.typo.shortname(xGestor?.pessoa_fantasia || '', 20)}`}
                            </Button>
                          </Stack>
                        )}
                      </Stack>
                      <Stack direction="row" alignItems="flex-start" gap={1}>
                        <Stack>
                          {xGestor?.logo_pessoa_id && (
                            <PessoaImage
                              logoPessoaId={xGestor.logo_pessoa_id}
                              alt={pAtivo?.pessoa || pAtivo?.emissor?.pessoa || ''}
                              hasLogo={xGestor.logo_ok}
                              size={32}
                            />
                          )}
                        </Stack>
                        <Stack direction="row" gap={2}>
                          <Stack>
                            <Typography
                              variant="caption"
                              color="textPrimary"
                              sx={{
                                fontWeight: 500
                              }}>
                              {xGestor?.pessoa_fantasia || '--'}
                            </Typography>

                            <Typography
                              variant="caption"
                              color="textPrimary"
                              noWrap
                              sx={{
                                fontWeight: 500
                              }}>
                              {displays.cnpj(xGestor?.cnpj) || '--'}
                            </Typography>
                          </Stack>
                        </Stack>
                      </Stack>
                    </Stack>
                    <Divider />
                    {/* Administrador */}
                    <Stack gap={1} sx={{ minHeight: '100px' }}>
                      <Stack direction="row" alignItems="center" justifyContent="space-between">
                        <Stack>
                          <Typography variant="caption" color="textPrimary">
                            <b>Administrador</b>
                          </Typography>
                        </Stack>

                        {pAtivo.adm_pessoa_id && (
                          <Stack>
                            <Button
                              component={Link}
                              title={pAtivo.adm?.pessoa_fantasia}
                              endIcon={<Icon iconName="arrow-next" size={12} />}
                              size="small"
                              to={`/empresas/${pAtivo.adm_pessoa_id}`}
                              sx={{
                                px: 2,
                                textTransform: 'capitalize'
                              }}>
                              {`${utils.typo.shortname(pAtivo.adm?.pessoa_fantasia || '', 20)}`}
                            </Button>
                          </Stack>
                        )}
                      </Stack>
                      <Stack direction="row" alignItems="flex-start" gap={1}>
                        <Stack>
                          <PessoaImage
                            logoPessoaId={pAtivo.adm?.logo_pessoa_id}
                            alt={pAtivo.adm?.pessoa_fantasia}
                            hasLogo={pAtivo.adm?.logo_ok || false}
                            size={32}
                          />
                        </Stack>
                        <Stack direction="row" gap={2}>
                          <Stack>
                            <Typography
                              variant="caption"
                              color="textPrimary"
                              sx={{
                                fontWeight: 500
                              }}>
                              {pAtivo.adm?.pessoa_fantasia || '--'}
                            </Typography>

                            <Typography
                              variant="caption"
                              color="textPrimary"
                              noWrap
                              sx={{
                                fontWeight: 500
                              }}>
                              {displays.cnpj(pAtivo.adm?.cnpj) || '--'}
                            </Typography>
                          </Stack>
                        </Stack>
                      </Stack>
                    </Stack>
                  </Stack>
                </React.Fragment>
              );
            })}
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  );
});

export default ComparadorGestorAdm;
